<template>
  <div class="manual-address">
    <div v-if="askForOrgName"
         class="form-group">
      <label :for="$id('org-name')">
        Organisation / School name:
      </label>

      <b-form-input :id="$id('org-name')"
                    v-model="address.orgName"
                    type="text">
      </b-form-input>

      <span v-if="showValidation && !address.orgName"
            class="validation-error">
        Please enter your Organisation / School name.
      </span>
    </div>
    <div class="form-group">
      <label :for="$id('address')">
        Address:
      </label>

      <b-form-input :id="$id('address')"
                    v-model="address.address1"
                    type="text">
      </b-form-input>

      <span v-if="showValidation && !address.address1"
            class="validation-error">
        Please enter your address.
      </span>
    </div>
    <div class="form-group">
      <label :for="$id('address2')">
        Address line 2:
      </label>

      <b-form-input :id="$id('address2')"
                    v-model="address.address2"
                    type="text">
      </b-form-input>
    </div>
    <div class="form-group">
      <label :for="$id('address3')">
        Address line 3:
      </label>

      <b-form-input :id="$id('address3')"
                    v-model="address.address3"
                    type="text">
      </b-form-input>
    </div>
    <div class="form-group">
      <label :for="$id('town')">
        Town:
      </label>

      <b-form-input :id="$id('town')"
                    v-model="address.town"
                    type="text">
      </b-form-input>

      <span v-if="showValidation && !address.town"
            class="validation-error">
        Please enter your Town.
      </span>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label :for="$id('region')">
            Region:
          </label>

          <b-form-input :id="$id('region')"
                        v-model="address.region"
                        type="text">
          </b-form-input>

          <span v-if="showValidation && !address.region"
                class="validation-error">
            Please enter your Region.
          </span>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="$id('postcode')">
            Postcode:
          </label>

          <b-form-input :id="$id('postcode')"
                        v-model="address.postcode"
                        type="text">
          </b-form-input>

          <span v-if="showValidation && !address.postcode"
                class="validation-error">
            Please enter your postcode.
          </span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label :for="$id('country')">
        Country:
      </label>

      <b-form-select :id="$id('country')"
                     v-model="address.countryId"
                     type="text">
        <b-form-select-option value="0"
                              selected>
          - Please select -
        </b-form-select-option>
        <b-form-select-option v-for="(country, index) in countries"
                              :key="index"
                              :value="country.countryId">
          {{ country.countryName }}
        </b-form-select-option>
      </b-form-select>

      <span v-if="showValidation && address.countryId ==='0'"
            class="validation-error">
        Please select your country
      </span>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEqual, get } from "lodash";
import { listCountries } from "~/Scripts/resources/addressSearchResource";
import AddressSearchMixin from "~/Scripts/mixins/AddressSearchMixin";

export default {

  mixins: [AddressSearchMixin],

  data () {
    return {
      enterManualAddress: false,
      countries: []
    };
  },

  computed: {
    /**
     * Whether we need to organisation name
     */
    askForOrgName () {
      return get( this.userType, "askForOrgName", false );
    }
  },

  watch: {
    /**
     * When the address linked to this component is changed, update the address
     * within the component
     */
    value: {
      deep: true,
      handler ( val ) {
        if ( !isEqual( val, this.address ) ) {
          this.address = cloneDeep( val );
        }
      }
    },

    /**
     * When the address in the component is changed,
     * emit the changes to the parent
     */
    address: {
      deep: true,
      handler ( val ) {
        this.$emit( "input", val );
      }
    }
  },

  mounted () {
    // Load the list of countries
    listCountries()
      .then( ( result ) => {
        this.countries = result.data || [];
      } )
      .catch( () => {
        this.countries = [];
      } );
  }
};
</script>

<style lang="less" scoped>
  .manual-address {
    .form-control {
      max-width: none;
    }
  }
</style>
